package com.evoapps.evoshift.domain.model

/**
 * Document ids derived from other ids (schema in AGENTS.md). Every place that builds or parses one
 * goes through here, so the formats cannot drift apart again.
 */
object RosterIds {
    /** `workplaceId_YYYY_MM`, e.g. `wp_gdansk_2026_02`. */
    fun of(workplaceId: String, year: Int, month: Int): String =
        "${workplaceId}_${year}_${month.toString().padStart(2, '0')}"

    /** (year, month) of every month touched by the ISO dates [startDate]..[endDate], in order. */
    fun monthsBetween(startDate: String, endDate: String): List<Pair<Int, Int>> {
        var year = startDate.take(4).toInt()
        var month = startDate.substring(5, 7).toInt()
        val endYear = endDate.take(4).toInt()
        val endMonth = endDate.substring(5, 7).toInt()
        val months = mutableListOf<Pair<Int, Int>>()
        while (year < endYear || (year == endYear && month <= endMonth)) {
            months += year to month
            if (++month > 12) { month = 1; year++ }
        }
        return months
    }

    /** (year, month) of a roster id. */
    fun yearMonthOf(rosterId: String): Pair<Int, Int> {
        val parts = rosterId.split('_')
        return parts[parts.size - 2].toInt() to parts.last().toInt()
    }

    /** The workplace part of a roster id (workplace ids may themselves contain underscores). */
    fun workplaceIdOf(rosterId: String): String =
        rosterId.substringBeforeLast("_").substringBeforeLast("_")
}

object DailyRecordIds {
    /** `workplaceId_YYYY_MM_DD`, e.g. `wp_gdansk_2026_02_01`. [date] is an ISO date. */
    fun of(workplaceId: String, date: String): String = "${workplaceId}_${date.replace('-', '_')}"
}
